import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseApiService } from '../../../core/base-api.service';
import { ApiResponse } from '../../api-response';
import { DeviceLog, DeviceLogDownloadResponse, DeviceLogType } from '../models/device-log.model';

@Injectable({ providedIn: 'root' })
export class DeviceLogsService extends BaseApiService {
  private readonly http = inject(HttpClient);
  private readonly coreLogsUrl = `${this.coreApiUrl}/api/v1/device/upload-logs`;
  private readonly fmLogsUrl = `${this.coreApiUrl}/api/v1/device-logs`;

  requestUpload(deviceId: number, logType: DeviceLogType = 'SYSTEM'): Observable<ApiResponse<null>> {
    const params = new HttpParams().set('deviceId', deviceId).set('logType', logType);
    return this.http.post<ApiResponse<null>>(this.coreLogsUrl, null, { params });
  }

  list(deviceId: number, page = 0, size = 20): Observable<ApiResponse<DeviceLog[]>> {
    const params = new HttpParams()
      .set('deviceId', deviceId)
      .set('page', page)
      .set('size', size);
    return this.http.get<ApiResponse<DeviceLog[]>>(this.fmLogsUrl, { params });
  }

  getDownloadUrl(id: string): Observable<DeviceLogDownloadResponse> {
    return this.http.get<DeviceLogDownloadResponse>(`${this.fmLogsUrl}/${id}/download`);
  }
}
